<template>
  <div class="third">
    <div class="third-formOne newSlideshow">
      <div class="formOne-btn">
        <div class="btn-left">
          <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>
          <span v-if="ID == null" class="left-back-content">新增轮播图</span>
          <span v-if="ID !== null" class="left-back-content">编辑轮播图</span>
        </div>
        <div class="btn-right">
          <el-button @click="resetForm('ruleForm')" class="btn-two" type="default">重置</el-button>
          <el-button @click="commit()" class="btn-two" type="primary" v-el-disabel-repeat-click>保存</el-button>
        </div>
      </div>
      <el-form
        @validate="validateValue"
        :show-message="false"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="86px"
      >
        <div class="formOne-forms">
          <div class="forms-one" style="margin-top: 57px;">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">基本信息</span>
              </div>
            </div>
            <div class="one-list">
              <el-form-item label="标题">
                <el-input
                  class="list-input"
                  :maxlength="20"
                  v-model.trim="ruleForm.title"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="排序" prop="sort">
                <el-input
                  class="list-input"
                  :maxlength="6"
                  v-model.trim="ruleForm.sort"
                  placeholder="请输入正整数"
                ></el-input>
              </el-form-item>
              <el-form-item label="图片" prop="imgUrl">
                <el-upload
                  class="list-upload-img"
                  :limit="1"
                  action="noUse"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :on-exceed="handleExceed"
                  :on-success="handleSuccess"
                  :on-error="hadleError"
                  :before-upload="beforeUpload"
                  :file-list="fileList"
                  :http-request="facUpload"
                  accept=".jpg, .jpeg, .png"
                  list-type="picture-card"
                  :class="{ fileDisabled: ruleForm.imgUrl !== '' }"
                >
                  <i class="el-icon-plus"></i>
                  <div class="list-upload-title">点击上传</div>
                  <!-- 这里需要根据UI设计后图片的实际尺寸补充的尺寸来改 -->
                  <div slot="tip" class="list-upload-tip">10M以内，支持扩展名.png、.jpg、.jpeg、.gif，建议尺寸（1404*540px）</div>
                </el-upload>
              </el-form-item>
              <!-- <el-form-item label="标题栏背景色" prop="footColor">
                <div class="footColor-list">
                  <div v-for="(item, index) in colorList" :key="index" @click="choseItem(item)" :style="{ backgroundColor: item.color }" class="footColor-list-item" :class="item.choosed ? 'footColor-item-choosed' : ''"></div>
                </div>
                <el-button class="btn-two" type="primary" @click="preBg">预览</el-button>
              </el-form-item> -->
              <el-form-item label="网址" prop="detailUrl">
                <el-input
                  class="list-input"
                  :maxlength="1000"
                  v-model.trim="ruleForm.detailUrl"
                  placeholder="请完整输入http(s)"
                ></el-input>
              </el-form-item>
              <el-form-item label="自动停用时间">
                <el-date-picker
                  class="list-input"
                  v-model="ruleForm.stopTime"
                  type="date"
                  align="right"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="请选择"
                ></el-date-picker>
              </el-form-item>
              <el-form-item
                label="状态"
                prop="status">
                <el-radio-group v-model="ruleForm.status">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <preview-modal
      :previewModal="dialogVisible"
      :previewImageUrl="dialogImageUrl"
      @previewClose="closePreview"
    ></preview-modal>
    <el-dialog class="New-slideshow-modal" width="504px" :visible.sync="bgPreModal" :show-close="false" v-el-drag-dialog :close-on-click-modal='false'>
      <div slot="title" class="slideshow-modal-title">
        <span class="modal-title-icon" @click="closeModal">
          <i class="el-icon-circle-close"></i>
        </span>
      </div>
			<div class="slideshow-content">
        <img class="slideshow-modal-img" :onerror="errorImgRectangle" :src="previewImageUrl" alt="">
        <!-- 需要根据选择的背景色动态绑定 -->
        <div class="slideshow-modal-bg" :style="{ backgroundColor: ruleForm.footColor}">
          <!-- 根据有无网址动态计算宽度 -->
          <div class="bg-title" :style="ruleForm.detailUrl ? '' : { width: '100%' }">{{ruleForm.title}}</div>
          <!-- 有网址时显示详情 -->
          <div class="bg-detail" v-if="ruleForm.detailUrl">
            <span>详情</span>
          </div>
        </div>
      </div>
		</el-dialog>
  </div>
</template>

<script>
import { upicon, add } from "@/api/slidenshow/slidenshow";

export default {
  name: "formSeven",
  props: ["ID"],
  data() {
    const blurText = async (rule, value, callback) => {
      const boolean = new RegExp("^[1-9][0-9]*$").test(value); // console.log(boolean)
      if (!boolean) {
        callback(new Error("请输入正整数"));
      }
    };
    return {
      previewImageUrl: '', // 预览图片
      bgPreModal: false, // 背景预览弹窗
      countNum: 1, //用于显示第一个错误
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [], // 上传文件列表
      pointList: [],
      rules: {
        sort: [
          { required: true, message: "请输入排序序号", trigger: "blur" },
          { validator: blurText, trigger: "blur" } //表单验证的时候会调用的方法
        ],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        imgUrl: [{ required: true, message: "请上传图片", trigger: "blur" }],
        detailUrl: [
          { type: "string", pattern: /^http[s]?:\/\/.*/, message:"请完整输入http(s)", trigger: blur}
        ],
        status: [{ required: true, message: "请选择状态", trigger: "blur" }],
        footColor: [{ required: true, message: "请选择标题栏背景色", trigger: "blur" }]
      },
      ruleForm: {
        id: "",
        sort: "", // 排序序号
        title: "", // 标题
        imgUrl: "", // 图片
        footColor: '', // 标题栏背景色
        detailUrl: "", // 网址
        stopTime: "", //自动停用时间
        status: 1 // 状态
      },
      uploadFilter: ['.jpg', '.jpeg', '.png'],
      canAdd: true, // 是否可以新增
      colorList: [
        {
          color: '#3393FF',
          choosed: false,
        },
        {
          color: '#1FC4C4',
          choosed: false,
        },
        {
          color: '#FFA759',
          choosed: false,
        },
        {
          color: '#8C8CFF',
          choosed: false,
        },
        {
          color: '#FF9966',
          choosed: false,
        },
        {
          color: '#528BFF',
          choosed: false,
        },
        {
          color: '#FFB145',
          choosed: false,
        },
        {
          color: '#33BBFF',
          choosed: false,
        },
        {
          color: '#1FCC95',
          choosed: false,
        },
      ]
    };
  },
  created() {
    if (this.ID !== null) {
      this.selectinfo();
    }
  },
  methods: {
    // 选中颜色
    choseItem(item) {
      item.choosed = !item.choosed
      if (item.choosed) {
        this.ruleForm.footColor = item.color
      } else {
        this.ruleForm.footColor = ''
      }
      this.colorList.forEach(element => {
        element.choosed = false
        if (element.color === item.color) {
          element.choosed = true
        }
      });
    },
    // 背景预览
    preBg() {
      const res = this.fliterPre()
      if (res) {
        this.previewImageUrl = this.ruleForm.imgUrl
        this.bgPreModal = true
      }
    },
    // 过滤预览验证
    fliterPre() {
      this.countNum = 0
      let res = false
      this.$refs.ruleForm.validateField('title', (msg) => {
        console.log(msg)
        if (msg) {
          res = true
        }
      })
      if (res) {
        return
      }
      this.$refs.ruleForm.validateField('sort', (msg) => {
        console.log(msg)
        if (msg) {
          res = true
        }
      })
      if (res) {
        return
      }
      this.$refs.ruleForm.validateField('imgUrl', (msg) => {
        console.log(msg)
        if (msg) {
          res = true
        }
      })
      if (res) {
        return
      }
      this.$refs.ruleForm.validateField('footColor', (msg) => {
        console.log(msg)
        if (msg) {
          res = true
        }
      })
      if (!res) {
        this.countNum = 1
        return true
      }
    },
    // 关闭弹窗
    closeModal() {
      this.bgPreModal = false
    },
    goBack() {
      this.$emit("backHome");
    },
    //上传图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //移除
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.imgUrl = "";
    },
    // 超出
    handleExceed(files, fileList) {
      console.log(files, fileList);
    },
    // 成功
    handleSuccess() {
      console.log(this.fileList);
      console.log(111);
    },
    // 上传之前
    beforeUpload (file) {
      let testSuffix = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
      // console.log(testSuffix)
      let res = this.filterFileRes(testSuffix, this.uploadFilter)
      if (!res) {
        this.$message.error('上传文件格式错误')
        return false
      }
      const  isLt5M = file.size / 1024 / 1024 <= 10;
      if (!isLt5M) {
        this.$message.error("上传文件大小10M以内");
        return false
      }
      // console.log(this.userInfo.userId)
    },
    // 验证格式
    filterFileRes (testSuffix, uploadFilter) {
      let matchingCount = false
      uploadFilter.forEach(element => {
        // console.log(element)
        if (element === testSuffix) {
          matchingCount = true
        }
      })
      return matchingCount
    },
    // 上传失败
    hadleError(err) {
      this.$message.error(err);
    },
    async facUpload(params) {
      console.log(params);
      try {
        let reqData = new FormData();
        reqData.append("tenantId", this.$store.state.user.tenantId);
        reqData.append("file", params.file);
        // const reqData = {
        //   tenantId: this.$store.state.user.tenantId, //大学id  （当前登录用户id）
        //   file:params.file
        // };
        await upicon(reqData).then(res => {
          const data = res.data;
          console.log("这是图片上传接口", data);
          if (data.success === 1) {
            this.$message.success("上传图片成功");
            // this.fileList.url = data.result;
            // this.fileList.push({
            //   // name: params.file.name,
            //   url: data.result
            // });
            this.ruleForm.imgUrl = data.data[0].oUrl;
            console.log("上传的图片文件", this.ruleForm.imgUrl);
          } else {
            this.$message.error(data.msg);
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //获取学校详情
    selectinfo() {
      // debugger
      this.fileList = [];
      this.ruleForm = this.ID;
      if (this.ruleForm.imgUrl !== "") {
        this.fileList.push({
          url: this.ruleForm.imgUrl
        });
      }
      this.colorList.forEach(element => {
        element.choosed = false
        if (element.color === this.ID.footColor) {
          element.choosed = true
        }
      });
      console.log(this.ruleForm)
    },
    // 提交表单
    commit() {
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs.ruleForm.validate(valid => {
          console.log("valid", valid);
          if (valid) {
            this.countNum = 1;
            if (this.canAdd) {
              this.save();
            }
          } else {
            return false;
          }
        });
      });
    },
    // 验证
    validateValue(prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    //新增/修改学校信息
    save() {
      this.canAdd = false
      try {
        let id = null;
        if (this.ID == null) {
          id = 0;
        } else {
          id = this.ruleForm.id;
        }
        // let sort = Number(this.ruleForm.sort)
        const params = {
          id: id, //轮播图ID  新增时为-1或者0
          sort: this.ruleForm.sort, //排序序号
          title: this.ruleForm.title, //标题
          imgUrl: this.ruleForm.imgUrl, //图片地址
          detailUrl: this.ruleForm.detailUrl, //网址
          stopTime: this.ruleForm.stopTime, //自动停用时间
          status: this.ruleForm.status, //轮播图状态 1启用 0停用
          footColor: this.ruleForm.footColor //轮播图状态 1启用 0停用
        };
        add(params).then(res => {
          const data = res.data;
          console.log("这是轮播图新增/编辑接口", data);
          if (data.status === 1000) {
            this.$message.success("保存成功");
            this.canAdd = true
            this.goBack();
          } else {
            this.canAdd = true
            this.$message.error(data.msg);
          }
        });
      } catch (err) {
        this.canAdd = true
        this.$message.error(err);
        console.log(err);
      }
    },
    //表单验证
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //表单重置
    resetForm(formName) {
      // this.ruleForm.administrativeArea = [];
      // this.ruleForm.createTime = "";
      // this.ruleForm.director = "";
      // this.ruleForm.directorId = "";
      // this.ruleForm.foundingYear = "";
      // this.ruleForm.presidentId = "";
      // this.ruleForm.presidentName = "";
      // this.ruleForm.schoolAnniversary = "";
      // this.ruleForm.updateTime = "";
      // console.log("重置", this.ruleForm);
      if (this.ID !== null) {
        this.$refs[formName].resetFields();
        this.selectinfo();
      } else {
        this.$refs[formName].resetFields();
        this.fileList = [];
        this.ruleForm.stopTime = "";
        this.ruleForm.detailUrl = "";
      }
      this.colorList.forEach(element => {
        element.choosed = false
      });
      console.log("重置", this.ruleForm);
    },
    //关闭预览弹窗
    closePreview() {
      this.dialogVisible = false;
    },
    //行政区域选中节点
    handleChange(value) {
      console.log(value);
    }
  }
};
</script>

<style lang="scss">
.New-slideshow-modal {
  .el-dialog__header {
    padding: 0;
    position: relative;
    .slideshow-modal-title {
      display: inline-block;
      position: absolute;
      top: -24px;
      right: -24px;
      .modal-title-icon {
        color: #fff;
        font-size: 24px;
        cursor: pointer;
      }
    }
  }
  .el-dialog__body {
    text-align: center;
    padding: 12px 16px;
    font-size: 0;
    .slideshow-content {
      position: relative;
      border-radius: 13px;
      overflow: hidden;
      .slideshow-modal-img {
        background-color: rgba(0, 0, 0, .2);
        min-width: 100%;
        max-width: 100%;
        max-height: 600px;
      }
      .slideshow-modal-bg {
        width: 100%;
        position: absolute;
        font-size: 0;
        bottom: 0;
        padding: 10px;
        .bg-title {
          text-align: left;
          display: inline-block;
          vertical-align: top;
          height: 22px;
          line-height: 22px;
          font-size: 13px;
          color: #ffffff;
          font-weight: bold;
          width: calc(100% - 42px);
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .bg-detail {
          display: inline-block;
          vertical-align: top;
          text-align: left;
          width: 42px;
          span {
            // cursor: pointer;
            text-align: center;
            display: inline-block;
            vertical-align: middle;
            width: 42px;
            height: 22px;
            line-height: 22px;
            color: #ffffff;
            border-radius: 11px;
            font-size: 13px;
            background: rgba(255, 255, 255, .2);
          }
        }
      }
    }
  }
}
.newSlideshow {
  height: 100vh !important;
  .footColor-list {
    display: inline-block;
    vertical-align: top;
    font-size: 0;
    .footColor-list-item {
      display: inline-block;
      vertical-align: top;
      cursor: pointer;
      width: 28px;
      height: 28px;
      margin-right: 8px;
      box-shadow: none;
      transform: scale(1);
      transition: all 0.3s ease-in-out;
    }
    .footColor-item-choosed {
      transform: scale(1.14);
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.35);
    }
  }
  .fileDisabled {
    .el-upload--picture-card {
      display: none;
    }
  }
}
</style>
